import { SVGProps } from 'react';

const ModelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    {...props}
  >
    <path d="m23.212 5.74-4.853-2.646A.75.75 0 0 0 18 3h-3a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 3H6a.75.75 0 0 0-.36.094L.788 5.739a1.477 1.477 0 0 0-.617 1.994l1.806 3.45A1.534 1.534 0 0 0 3.344 12H5.25v7.5a1.5 1.5 0 0 0 1.5 1.5h10.5a1.5 1.5 0 0 0 1.5-1.5V12h1.907a1.535 1.535 0 0 0 1.367-.817l1.806-3.45a1.477 1.477 0 0 0-.618-1.994ZM3.344 10.5a.058.058 0 0 1-.038-.012L1.508 7.056 5.25 5.014V10.5H3.344Zm17.35-.013a.052.052 0 0 1-.038.013H18.75V5.014l3.742 2.042-1.798 3.43Z" />
  </svg>
);

export default ModelIcon;
